import React, { useEffect, useRef, useState } from "react";
import NavBar from "../commonComponents.jsx/NavBar";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "../components/SideBar";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import StockReportTemplate from "../components/StockTemplate";
import StockDetails from "../components/StockDetils";
import { useNavigate } from "react-router-dom";
import StockDetailsWithProducts from "../components/stockdetailswithProducts";
import LocationDropdown from "../commonComponents.jsx/LocationDropdown";
import down from "../images/address.png";

ChartJS.register(ArcElement, Tooltip, Legend);

const StockReportWithProducts = () => {
  const nav = useNavigate();
  const sidebarRef = useRef(null);
  const [isSideBar, setIsSideBar] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedLocationData, setSelectedLocationData] = useState(null);
  const [isStockDetails, setIsStockDetails] = useState(false);
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [filterLocations, setFilterLocations] = useState([]);
  const [pending, setPending] = useState(false);
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const locationRef = useRef(null);
  const [reportData, setReportData] = useState();
  const clientid = sessionStorage.getItem("clientId");
  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const locations = JSON.parse(sessionStorage.getItem("locations") || "[]");
  const filteredLocationsId = filterLocations.map((item) => item.locationID);

  useEffect(() => {
    if (adminInfo?.multiple_location.length !== 0) {
      const fetchDataOnFromDateChange = async () => {
        setPending(true);
        try {
          const token = sessionStorage.getItem("token");
          const selectedLocationID = JSON.parse(
            sessionStorage.getItem("selectedLocation"),
          );
          const selectedLocation = JSON.parse(
            sessionStorage.getItem("locations") || "[]",
          );

          const requestBody = {
            id: selectedLocationID || "",
            dataurl: `/api/DashBoardLocationDepartmentWiseStock/WithProducts`,
            subdata: {
              Loations: selectedLocation || [],
            },
          };

          const { data } = await axios.post(
            `${process.env.REACT_APP_BACKEND_API_URL}/clients/multipleLocations-summarydetails`,
            requestBody,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            },
          );

          const datas = data?.result;
          setPending(false);
          setReportData(datas);
        } catch (error) {
          console.error("Error fetching data on date change:", error);
        } finally {
          setPending(false);
        }
      };

      fetchDataOnFromDateChange();
    }
  }, []);

  const fetchLocations = async ({ queryKey }) => {
    const [, { clientid, locations }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid || locations.length === 0) {
      throw new Error("Missing required parameters");
    }

    const requestBody = {
      clientid: clientid,
      dataurl: "/api/Location",
      type: "get",
      subdata: {
        loations: locations,
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const shouldFetchLocations = adminInfo?.multiple_location?.length === 0;

  const { data: locationData = [] } = useQuery({
    queryKey: ["locations", { clientid, locations }],
    queryFn: fetchLocations,
    enabled: shouldFetchLocations && !!clientid && locations.length > 0,
    staleTime: 1000 * 60 * 5,
  });

  const fetchStockReport = async ({ queryKey }) => {
    const [, { clientid }] = queryKey;

    const token = sessionStorage.getItem("token");

    if (!token || !clientid) {
      throw new Error("Missing required parameters");
    }

    const requestBody = {
      clientid: clientid,
      dataurl: "/api/DashBoardLocationDepartmentWiseStock/WithProducts",
      subdata: {
        loations:
          filteredLocationsId.length > 0 ? filteredLocationsId : [],
      },
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_API_URL}/clients/summarydetails`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data.result;
  };

  const {
    data: stockReportData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["hourlysales", { clientid }],
    queryFn: fetchStockReport,
    enabled: !!clientid && adminInfo?.multiple_location?.length === 0 && filteredLocationsId.length>0,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsSideBar(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
      }
      if (locationRef.current && !locationRef.current.contains(event.target)) {
        setIsStockDetails(false);
      }
    };

    if (isSideBar || isDropdownOpen || isFilterOpen || isStockDetails) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "auto";
    };
  }, [isSideBar, isDropdownOpen, isFilterOpen, isStockDetails]);



  const report = reportData
    ? reportData
    : stockReportData
      ? stockReportData
      : [];

  const handleViewDetails = (locationId) => {
    setIsStockDetails(true);
    const matched = report.departmentWiseSummary.find(
      (item) => item.locationID === locationId,
    );
    if (matched) {
      setSelectedLocationData(matched);
    }
  };

  const toggleLocationSelection = (location) => {
    setFilterLocations((prev) => {
      const newLocations = prev.some(
        (selectedLocation) =>
          selectedLocation.locationID === location.locationID,
      )
        ? prev.filter((l) => l.locationID !== location.locationID)
        : [...prev, location];

      return newLocations.length === 0 ? [] : newLocations;
    });
  };

  const getDisplayText = (locations) => {
    if (locations.length === 0) {
      return "No Locations Selected";
    }

    return locations.length > 2
      ? `${locations[0].locationName}, +${locations.length - 1} more`
      : locations.map((location) => location.locationName).join(", ");
  };

  return (
    <div className="min-h-[100dvh] bg-gray-50 overflow-hidden">
      <div className="max-w-[768px] mx-auto relative">
        <AnimatePresence>
          {isSideBar && (
            <>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.5 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 bg-black z-50 "
                onClick={() => setIsSideBar(false)} // optional: clicking outside closes
              />
              <motion.div
                initial={{ x: -300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -300, opacity: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 20,
                  duration: 0.3,
                }}
                className="absolute w-80 h-full overflow-hidden overflow-y-auto z-50 bg-white"
              >
                <Sidebar
                  onHide={() => setIsSideBar(false)}
                  page={"Department Wise Stock With Products"}
                />
              </motion.div>
            </>
          )}
        </AnimatePresence>
        <AnimatePresence>
          {isStockDetails && selectedLocationData && (
            <>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.5 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 bg-black z-50 "
                onClick={() => setIsStockDetails(false)} // optional: clicking outside closes
              />
              <motion.div
                ref={locationRef}
                initial={{ y: 600, opacity: 0 }}
                animate={{ y: 100, opacity: 1 }}
                exit={{ y: 600, opacity: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 20,
                  duration: 0.3,
                }}
                className="absolute w-full h-full rounded-xl overflow-y-auto z-50 bg-white"
              >
                <StockDetailsWithProducts
                  onBack={() => setIsStockDetails(false)}
                  stockSummary={selectedLocationData}
                />
              </motion.div>
            </>
          )}
        </AnimatePresence>

        <div className="bg-[#F3F3F3] rounded-3xl overflow-y-auto shadow-sm p-4 h-[100dvh]">
          <NavBar onSideBar={() => setIsSideBar(true)} />

          {/* Title and Filter Button */}
          <div className="flex justify-between items-center mb-4">
            <div className="relative inline-block ">
              <div
                className="
                                bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 border border-indigo-100
                                shadow-sm shadow-indigo-100
                                transition-all duration-300
                                overflow-hidden
                            "
              >
                <h1
                  className="
                                    text-sm 
                                    text-indigo-600
                                    relative z-10
                                    transition-all duration-300
                                    font-QBold
                                    "
                >
                  Department Wise Stock With Products
                </h1>
              </div>
            </div>
          </div>
          {adminInfo?.multiple_location &&
          adminInfo.multiple_location.length > 0 ? (
            <button
              onClick={() => setIsLocationModalOpen(true)}
              className="mt-4 px-4 py-2 flex justify-between items-center gap-x-2 bg-indigo-700 rounded-xl text-white mb-3 text-sm font-QMedium tracking-tight  whitespace-nowrap"
            >
              Locations
              <img src={down} className="w-5 h-5" alt="" />
            </button>
          ) : (
            <LocationDropdown
              dropdownRef={dropdownRef}
              isDropdownOpen={isDropdownOpen}
              setIsDropdownOpen={setIsDropdownOpen}
              filterLocations={filterLocations}
              locations={locationData}
              toggleLocationSelection={toggleLocationSelection}
              getDisplayText={getDisplayText}
              onApply={() => {
                refetch();
              }}
            />
          )}
          {/* Custom Styled Pie Chart */}
          {isLoading || isFetching || pending ? (
            <div className="flex justify-center items-center py-6">
              <div className="w-6 h-6 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : report && report.summary && report.summary.length > 0 ? (
            <StockReportTemplate
              onViewDetails={handleViewDetails}
              stockReport={report.summary}
            />
          ) : (
            <div className="text-center text-gray-500 font-QSemiBold py-10">
              No stock report data found.
            </div>
          )}

          <div className="h-20"></div>

          {/* Bottom Nav */}
          <nav className="fixed z-50 rounded-t-3xl text-[20px] max-w-[768px] mx-auto bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-3 px-6 flex justify-between">
            <NavButton
              path="/dashboard"
              navigateTo={nav}
              icon={<i className="ri-home-line"></i>}
              active
            />
            <NavButton
              path="/dept-sales"
              navigateTo={nav}
              icon={<i className="ri-building-line"></i>}
            />
            <NavButton
              path="/hourly-sales"
              navigateTo={nav}
              icon={<i className="ri-time-line"></i>}
            />
            <NavButton
              path="/top-products"
              navigateTo={nav}
              icon={<i className="ri-fire-line"></i>}
            />
          </nav>
        </div>
      </div>
    </div>
  );
};

const NavButton = ({ icon, path, navigateTo, active = false }) => (
  <button
    onClick={() => navigateTo(path)}
    className={`p-2 rounded-full ${
      active ? "text-indigo-600" : "text-gray-500"
    }`}
  >
    {icon}
  </button>
);

export default StockReportWithProducts;
